module.exports = __webpack_public_path__ + "static/media/play.b7663684.svg";